import { BaseComponent2 } from '../../_common/client/base-component2';
import { addMoveTrackingToLink } from './add-move-tracking-to-link';

export class CustomerReviewRatingComponent extends BaseComponent2 {
    public rootSelector = '.js_pdp_cr-rating';
    public async init(): Promise<void> {
        if (!this.isPresent()) return;
        const linkElement = this.getChildElement('.js_pdp_cr-rating--link');
        if (linkElement) {
            addMoveTrackingToLink(linkElement);
        }
    }
}
